import { AUDIT_HISTORY_ACTIONS } from '@client/enums/audit-history-actions';
import { AUDIT_HISTORY_TYPES } from '@client/enums/audit-history-types';

export const AUDIT_HISTORY_FILTERS = {
  actions: {
    login: {
      label: AUDIT_HISTORY_ACTIONS.login.label,
      value: AUDIT_HISTORY_ACTIONS.login.id,
      enabled: false
    },
    create: {
      label: AUDIT_HISTORY_ACTIONS.create.label,
      value: AUDIT_HISTORY_ACTIONS.create.id,
      enabled: false
    },
    delete: {
      label: AUDIT_HISTORY_ACTIONS.delete.label,
      value: AUDIT_HISTORY_ACTIONS.delete.id,
      enabled: false
    },
    editgoogle: {
      label: AUDIT_HISTORY_ACTIONS.editgoogle.label,
      value: AUDIT_HISTORY_ACTIONS.editgoogle.id,
      enabled: false
    },
    pushfrontapp: {
      label: AUDIT_HISTORY_ACTIONS.pushfrontapp.label,
      value: AUDIT_HISTORY_ACTIONS.pushfrontapp.id,
      enabled: false
    },
    pushgoogle: {
      label: AUDIT_HISTORY_ACTIONS.pushgoogle.label,
      value: AUDIT_HISTORY_ACTIONS.pushgoogle.id,
      enabled: false
    },
    pusho365: {
      label: AUDIT_HISTORY_ACTIONS.pusho365.label,
      value: AUDIT_HISTORY_ACTIONS.pusho365.id,
      enabled: false
    },
    pushoutreach: {
      label: AUDIT_HISTORY_ACTIONS.pushoutreach.label,
      value: AUDIT_HISTORY_ACTIONS.pushoutreach.id,
      enabled: false
    },
    pushsalesforce: {
      label: AUDIT_HISTORY_ACTIONS.pushsalesforce.label,
      value: AUDIT_HISTORY_ACTIONS.pushsalesforce.id,
      enabled: false
    },
    pushemail: {
      label: AUDIT_HISTORY_ACTIONS.pushemail.label,
      value: AUDIT_HISTORY_ACTIONS.pushemail.id,
      enabled: false
    },
    syncbamboohrusers: {
      label: AUDIT_HISTORY_ACTIONS.syncbamboohrusers.label,
      value: AUDIT_HISTORY_ACTIONS.syncbamboohrusers.id,
      enabled: false
    },
    syncmangoappsusers: {
      label: AUDIT_HISTORY_ACTIONS.syncmangoappsusers.label,
      value: AUDIT_HISTORY_ACTIONS.syncmangoappsusers.id,
      enabled: false
    },
    synccalendlyusers: {
      label: AUDIT_HISTORY_ACTIONS.synccalendlyusers.label,
      value: AUDIT_HISTORY_ACTIONS.synccalendlyusers.id,
      enabled: false
    },
    synccsvusers: {
      label: AUDIT_HISTORY_ACTIONS.synccsvusers.label,
      value: AUDIT_HISTORY_ACTIONS.synccsvusers.id,
      enabled: false
    },
    syncgappsgroups: {
      label: AUDIT_HISTORY_ACTIONS.syncgappsgroups.label,
      value: AUDIT_HISTORY_ACTIONS.syncgappsgroups.id,
      enabled: false
    },
    syncgappsorgs: {
      label: AUDIT_HISTORY_ACTIONS.syncgappsorgs.label,
      value: AUDIT_HISTORY_ACTIONS.syncgappsorgs.id,
      enabled: false
    },
    syncgappsusers: {
      label: AUDIT_HISTORY_ACTIONS.syncgappsusers.label,
      value: AUDIT_HISTORY_ACTIONS.syncgappsusers.id,
      enabled: false
    },
    synco365users: {
      label: AUDIT_HISTORY_ACTIONS.synco365users.label,
      value: AUDIT_HISTORY_ACTIONS.synco365users.id,
      enabled: false
    },
    synco365groups: {
      label: AUDIT_HISTORY_ACTIONS.synco365groups.label,
      value: AUDIT_HISTORY_ACTIONS.synco365groups.id,
      enabled: false
    },
    syncsalesforceusers: {
      label: AUDIT_HISTORY_ACTIONS.syncsalesforceusers.label,
      value: AUDIT_HISTORY_ACTIONS.syncsalesforceusers.id,
      enabled: false
    },
    update: {
      label: AUDIT_HISTORY_ACTIONS.update.label,
      value: AUDIT_HISTORY_ACTIONS.update.id,
      enabled: false
    },
    updateuser: {
      label: AUDIT_HISTORY_ACTIONS.updateuser.label,
      value: AUDIT_HISTORY_ACTIONS.updateuser.id,
      enabled: false
    }
  },
  types: {
    abm: {
      label: AUDIT_HISTORY_TYPES.abm.label,
      value: AUDIT_HISTORY_TYPES.abm.id,
      enabled: false
    },
    ads: {
      label: AUDIT_HISTORY_TYPES.ads.label,
      value: AUDIT_HISTORY_TYPES.ads.id,
      enabled: false
    },
    bizcards: {
      label: AUDIT_HISTORY_TYPES.bizcards.label,
      value: AUDIT_HISTORY_TYPES.bizcards.id,
      enabled: false
    },
    bizcardroutes: {
      label: AUDIT_HISTORY_TYPES.bizcardroutes.label,
      value: AUDIT_HISTORY_TYPES.bizcardroutes.id,
      enabled: false
    },
    brandkit: {
      label: AUDIT_HISTORY_TYPES.brandkit.label,
      value: AUDIT_HISTORY_TYPES.brandkit.id,
      enabled: false
    },
    brandkitroutes: {
      label: AUDIT_HISTORY_TYPES.brandkitroutes.label,
      value: AUDIT_HISTORY_TYPES.brandkitroutes.id,
      enabled: false
    },
    csv: {
      label: AUDIT_HISTORY_TYPES.csv.label,
      value: AUDIT_HISTORY_TYPES.csv.id,
      enabled: false
    },
    domain: {
      label: AUDIT_HISTORY_TYPES.domain.label,
      value: AUDIT_HISTORY_TYPES.domain.id,
      enabled: false
    },
    domainsettings: {
      label: AUDIT_HISTORY_TYPES.domainsettings.label,
      value: AUDIT_HISTORY_TYPES.domainsettings.id,
      enabled: false
    },
    documents: {
      label: AUDIT_HISTORY_TYPES.documents.label,
      value: AUDIT_HISTORY_TYPES.documents.id,
      enabled: false
    },
    images: {
      label: AUDIT_HISTORY_TYPES.images.label,
      value: AUDIT_HISTORY_TYPES.images.id,
      enabled: false
    },
    manual: {
      label: AUDIT_HISTORY_TYPES.manual.label,
      value: AUDIT_HISTORY_TYPES.manual.id,
      enabled: false
    },
    outlookaddin: {
      label: AUDIT_HISTORY_TYPES.outlookaddin.label,
      value: AUDIT_HISTORY_TYPES.outlookaddin.id,
      enabled: false
    },
    plugins: {
      label: AUDIT_HISTORY_TYPES.plugins.label,
      value: AUDIT_HISTORY_TYPES.plugins.id,
      enabled: false
    },
    sendergroups: {
      label: AUDIT_HISTORY_TYPES.sendergroups.label,
      value: AUDIT_HISTORY_TYPES.sendergroups.id,
      enabled: false
    },
    signatures: {
      label: AUDIT_HISTORY_TYPES.signatures.label,
      value: AUDIT_HISTORY_TYPES.signatures.id,
      enabled: false
    },
    surveys: {
      label: AUDIT_HISTORY_TYPES.surveys.label,
      value: AUDIT_HISTORY_TYPES.surveys.id,
      enabled: false
    },
    tagblocks: {
      label: AUDIT_HISTORY_TYPES.tagblocks.label,
      value: AUDIT_HISTORY_TYPES.tagblocks.id,
      enabled: false
    },
    user: {
      label: AUDIT_HISTORY_TYPES.user.label,
      value: AUDIT_HISTORY_TYPES.user.id,
      enabled: false
    }
  },
  timeframe: {
    30: {
      label: 'label.TIME_PERIOD',
      value: 30,
      amount: 30,
      time: 'label.DAYS',
      enabled: false
    },
    60: {
      label: 'label.TIME_PERIOD',
      value: 60,
      amount: 60,
      time: 'label.DAYS',
      enabled: false
    },
    90: {
      label: 'label.TIME_PERIOD',
      value: 90,
      amount: 90,
      time: 'label.DAYS',
      enabled: false
    },
    365: {
      label: 'label.TIME_PERIOD',
      value: 365,
      amount: 1,
      time: 'label.YEAR',
      enabled: false
    },
    730: {
      label: 'label.TIME_PERIOD',
      value: 730,
      amount: 2,
      time: 'label.YEARS',
      enabled: false
    }
  }
};
